
@if (isLocationCard()) {
  <app-end-location-main
    [title]="title()"
    [startDate]="startDate()"
  />
  
} @else {
  <app-regular-main
    [title]="title()"
    [durationMinutes]="durationMinutes()"
    [isDuration15Minutes]="isDuration15Minutes()"
  />
}
